
import { Load } from '../../types';

// First floor loads
export const firstFloorLoads: Load[] = [
  {
    id: '2',
    name: 'HVAC System',
    type: 'hvac',
    status: false,
    location: 'Executive Office',
    powerRating: '3500W',
    currentConsumption: '0W',
    schedules: [
      {
        id: '2-1',
        days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
        startTime: '07:00',
        endTime: '19:00',
        enabled: true,
      }
    ],
    recommendations: [
      {
        id: '2-rec-1',
        description: 'Install a programmable thermostat',
        potentialSavings: '350kWh/month',
        priority: 'high'
      },
      {
        id: '2-rec-2',
        description: 'Service HVAC filters monthly',
        potentialSavings: '175kWh/month',
        priority: 'medium'
      }
    ]
  },
  {
    id: '5',
    name: 'Office Lighting',
    type: 'lighting',
    status: true,
    location: 'Open Office Area',
    powerRating: '450W',
    currentConsumption: '430W',
    schedules: [
      {
        id: '5-1',
        days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
        startTime: '08:00',
        endTime: '18:00',
        enabled: true,
      }
    ],
    recommendations: [
      {
        id: '5-rec-1',
        description: 'Install motion sensors in open office',
        potentialSavings: '90kWh/month',
        priority: 'high'
      }
    ]
  },
  {
    id: '6',
    name: 'Meeting Room Projector',
    type: 'entertainment',
    status: false,
    location: 'Meeting Room B',
    powerRating: '300W',
    currentConsumption: '0W',
    schedules: [],
    recommendations: [
      {
        id: '6-rec-1',
        description: 'Set up auto-shutdown after 30 minutes of inactivity',
        potentialSavings: '30kWh/month',
        priority: 'medium'
      }
    ]
  },
  {
    id: '7',
    name: 'IT Equipment',
    type: 'computing',
    status: true,
    location: 'IT Department',
    powerRating: '1200W',
    currentConsumption: '980W',
    schedules: [
      {
        id: '7-1',
        days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
        startTime: '07:30',
        endTime: '19:30',
        enabled: true,
      }
    ],
    recommendations: [
      {
        id: '7-rec-1',
        description: 'Implement power management on workstations',
        potentialSavings: '120kWh/month',
        priority: 'medium'
      }
    ]
  }
];
